import {SELECT_FOOTBALL_BET_TYPE} from '../constants/actionTypes';

export function selectFootballBetType(betType) {
    return {type: SELECT_FOOTBALL_BET_TYPE, betType};
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/football/actions/footballCardActions.js